module.exports = __webpack_public_path__ + "static/media/remove-from-newsletter-icon.6d9ccc34.svg";